export default {
  'aiSkillGroup.title': 'Gestionar Grupos de Skills',

  'aiSkillGroup.import.heroSummary':
    'Elige un repositorio Git o un archivo ZIP y previsualiza las skills antes de crear el grupo.',
  'aiSkillGroup.import.provider': 'Fuente',
  'aiSkillGroup.import.sourceUrl': 'URL del repositorio',
  'aiSkillGroup.import.sourcePath': 'Carpeta dentro del ZIP (opcional)',
  'aiSkillGroup.import.preview': 'Previsualizar',
  'aiSkillGroup.import.preview.title': 'Vista previa del grupo a importar',
  'aiSkillGroup.import.confirm': 'Confirmar importación',
  'aiSkillGroup.import.namePlaceholder': 'Nombre del grupo (puedes ajustarlo antes de confirmar)',
  'aiSkillGroup.import.descriptionPlaceholder': 'Descripción del grupo (opcional)',
  'aiSkillGroup.import.allowOverride.label': 'Conflictos',
  'aiSkillGroup.import.allowOverride': 'Permitir reasignar skills ya existentes en otros grupos',
  'aiSkillGroup.import.allowOverride.hint':
    'Si una skill ya pertenece a otro grupo, será movida a este grupo en lugar de generar un conflicto.',
  'aiSkillGroup.import.summary':
    'Total: {total} · Nuevas: {news} · Existentes: {existing} · Conflictos: {conflicts} · Inválidas: {invalid}',
  'aiSkillGroup.import.empty': 'La fuente no contiene skills detectables.',
  'aiSkillGroup.import.column.status': 'Estado',
  'aiSkillGroup.import.column.notes': 'Notas',
  'aiSkillGroup.import.status.new': 'Nueva',
  'aiSkillGroup.import.status.alreadyExists': 'Ya existe',
  'aiSkillGroup.import.status.conflict': 'Conflicto',
  'aiSkillGroup.import.status.invalid': 'Inválida',
  'aiSkillGroup.import.status.imported': 'Importada',
  'aiSkillGroup.import.status.skipped': 'Omitida',
  'aiSkillGroup.import.status.failed': 'Falló',
};
